// extracted by mini-css-extract-plugin
export default {"service":"Service_service__gM0qi","buttons":"Service_buttons__wH-jr","linkMore":"Service_linkMore__30-wt"};